/* @flow */
import * as React from 'react';

import Loading from 'components/Loading/Loading';
import ElectroCheckRadioGroup from 'forms/components/inputs/ElectroCheckRadioGroup/ElectroCheckRadioGroup';
import ElectroSimpleCheckbox from 'forms/components/inputs/ElectroSimpleCheckbox/ElectroSimpleCheckbox';

import CatalogueContext from '../utilities/CatalogueContext/CatalogueContext';

import s from '../RushAssetRequestForm.module.scss';

type DetailsSoftwareProps = {
  field: Object,
};

class DetailsSoftwareSection extends React.Component<DetailsSoftwareProps> {
  /** Each `software` that is part of a software
   * group will be separated and pushed into a new array. */
  groupSoftware(software: Object) {
    const groups = [];
    for (const asset of software) {
      // Only grouped software contain `group_key` values.
      if (asset.group_key) {
        if (!groups[asset.group_key]) {
          // If the group doesn't exist yet in the `groups`
          // array this will add the new group and push the current `asset`.
          groups[asset.group_key] = [];
          groups[asset.group_key].push(asset);
        }
        // If the group is already in the `groups` array, it just pushes the `asset`.
        else groups[asset.group_key].push(asset);
      }
    }
    return groups;
  }

  /** Here if the `software` is grouped, it'll be sent to a
   * `ElectroCheckRadioGroup` component, else,
   * it will just use a `ElectroSimpleCheckbox`. */
  buildRenderList(software: Object, groupMap: Object) {
    const { field } = this.props;
    const renderedGroups = new Set();
    const renderList = [];

    for (const asset of software) {
      // We check if he asset is a grouped software.
      if (asset.group_key) {
        // Now we check if this group is already part of the `renderedGroups` set
        // so we don't render it again even if we have more options.
        if (!renderedGroups.has(asset.group_key)) {
          // We add it to `renderedGroups` to avoid duplicates.
          renderedGroups.add(asset.group_key);
          // The component options expect an object with id and name,
          // so here we structure it properly.
          const resolvedSoftware = groupMap[asset.group_key].map(option => ({
            id: option.id,
            name: option.ui_displayed_description,
          }));
          // Finally, we add it to the `renderList` in the proper order.
          renderList.push(
            <React.Fragment key={asset.group_key}>
              <ElectroCheckRadioGroup
                field={field}
                options={resolvedSoftware}
                title={`${asset.group_name}`}
              />
            </React.Fragment>
          );
        }
      } else {
        // When a software is not part of a group, it has to be structured and added in order
        // to the `renderList` array.
        const resolvedSoftware = { id: asset.id, name: asset.ui_displayed_description };
        renderList.push(
          <React.Fragment key={asset.id}>
            <ElectroSimpleCheckbox field={field} option={resolvedSoftware} />
          </React.Fragment>
        );
      }
    }
    return renderList;
  }

  render() {
    return (
      <CatalogueContext.Consumer>
        {({ software, loading }) => {
          if (loading) return <Loading />;
          /** This makes sure the software uses the `dropdown_order` values. */
          const sortedSoftware = software.sort((a, b) => a.dropdown_order - b.dropdown_order);
          /** The softwares that should be together, are mapped in here. */
          const groupMap = this.groupSoftware(sortedSoftware);
          /** All components are added together, whether they are groups or singles. */
          const renderList = this.buildRenderList(sortedSoftware, groupMap);

          return (
            <>
              <p className={s['software-section__title']}>Software</p>
              <div className={s['software-section__container']}>{renderList}</div>
            </>
          );
        }}
      </CatalogueContext.Consumer>
    );
  }
}

export default DetailsSoftwareSection;
